import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/icons/title-logo.png";
import logoDark from "../../assets/icons/Froth_Logo.png";
import logofull from "../../assets/images/companies/froth_logo_full.png";
import logohalf from "../../assets/images/companies/forth-logo-half.png";

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu fixed" style={{position:'fixed'}}>
        <div className="navbar-brand-box" >
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm"  >
              <img src={logohalf} alt="" height="50"  style={{marginLeft:"-17px"}}/>
            </span>
            <span className="logo-lg">
              <img src={logofull} alt="" height="60"/>
            </span>
          </Link>

          <Link to="/" className="logo logo-light" >
            <span className="logo-sm" >
              <img src={logohalf} alt="" height="50" style={{marginLeft:"-17px"}} />
            </span>
            <span className="logo-lg">
              <img src={logofull} alt="" height="60" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
